import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#5F66E9',
    },
    secondary: {
      main: '#495AFF',
    },
  },
  typography: {
    fontFamily: 'Gabarito',
    button: {
      textTransform: 'none',
    },
  },
})

export default theme
